var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"disabled":this.filterIsLoading(this.module),"items":_vm.opponentsItems,"menu-props":_vm.menuProps,"item-text":"displayName","item-value":"id","label":"Opponent","outlined":"","dense":"","hide-details":""},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }